import React from 'react';
import styles from './A_HeaderItem.module.css';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';

interface A_HeaderItemProps {
  label?: string;
  icon?: React.ReactNode;
  to: string;
  active?: boolean;
  ariaLabel?: string;
  /** Счётчик непрочитанного рядом с иконкой; 0 скрывает индикатор. */
  badge?: number;
}

export default function A_HeaderItem({
  label,
  icon,
  to,
  active,
  ariaLabel,
  badge = 0,
}: A_HeaderItemProps) {
  const location = useLocation();
  const isActive = active !== undefined ? active : location.pathname === to;

  return (
    <Link
      to={to}
      className={cn(styles.wrapper, { [styles.active]: isActive })}
      aria-label={ariaLabel}
    >
      {icon && (
        <span className={styles.icon_wrapper}>
          {icon}
          {badge > 0 && (
            <span className={cn(styles.badge, 'text-caption')}>
              {badge > 99 ? '99+' : badge}
            </span>
          )}
        </span>
      )}
      {label && <span className={cn(styles.label, 'text-p-6')}>{label}</span>}
    </Link>
  );
}
